import { defineComponent, h } from 'vue';
import { QSelect, QIcon, QTooltip } from 'quasar';
import utils from '../../../../Shared/utils.jsx';
import methods from '../../../../Shared/methods';

export default defineComponent({
    name: 'string-lookup-list-dsgn',
    components: {
        QSelect,
        QIcon,
        QTooltip,
    },
    data: function () {
        return {
            condition_expn: null,
            list: null,
            lookupurl: null,
            displayexpn: null,
            valueexpn: null,
        }
    },
    created() {
    },
    computed: {
        ...utils.forms.computed,
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedNode == this;
        },
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        designmodel: null,
        schema: null,
        cmodel: null,
        extra: null,
        readonly: false,
        child: 0,
    },
    render() {
        const description = this.schema.description;

        return (
            <div
                class={{ 'designer-form': true }}
                style={{ xmarginLeft: (this.child * 15) + 'px', position: 'relative' }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                <QSelect
                    outlined
                    dense
                    label={this.name}
                    hint={description ?? ''}
                    options={[]}
                    modelValue={null}
                    style={{ width: '100%' }}
                >
                </QSelect>
            </div>
        );
    }
});